import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Img from "gatsby-image";
import { Link } from "gatsby";
import moment from "moment";

const useStyles = makeStyles({
  card: {
    width: "100%",
    borderRadius: 8,
    padding: 0,
    margin: 0,
    boxShadow: "0 3px 8px 2px rgba(0,0,0,0.08)",
    height: "100%",
  },
  continentCat: {
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: 12,
  },
  title: {
    fontWeight: 600,
  },
  body: {
    fontWeight: 400,
    color: "rgb(0,0,0)",
    marginBottom: 5,
  },
  tripBtn: {
    color: "#FB0051",
    fontWeight: 600,
  },
});

const EventCard = (props) => {
  const [calViewType, setCalViewType] = useState([true, false]);
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const featuredImage = () => {
    return (
      <Img
        fluid={props.img}
        style={
          props.calViewType[0] === true
            ? { height: 200 }
            : { height: "100%", maxHeight: matches ? "100%" : 200 }
        }
      ></Img>
    );
  };

  const dateStart = moment(props.startDate, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
  const dateEnd = moment(props.endDate, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
  const startDate = dateStart.toDate();
  const endDate = dateEnd.toDate();
  const days = props.days;
  useEffect(() => {
    setCalViewType(props.calViewType);
  }, [props.calViewType]);

  return (
    <>
      {calViewType[0] === true ? (
        <Card className={classes.card}>
          <CardMedia
            component={featuredImage}
            alt="Contemplative Reptile"
            title={props.title}
            image="Event Image"
          />
          <CardContent style={{ padding: "10px 10px", margin: 0 }}>
            <Grid container alignItems="center">
              <Grid item xs={12}>
                <Typography
                  gutterBottom
                  variant="body2"
                  component="h3"
                  className={classes.continentCat}
                >
                  <span style={{ color: theme.palette.primary.main }}>
                    {props.continent}
                  </span>
                  {" - " + props.category}
                </Typography>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="h2"
                  className={classes.title}
                >
                  {props.title}
                </Typography>
                <Typography
                  gutterBottom
                  variant="body2"
                  component="h2"
                  className={classes.body}
                >
                  Date:{" "}
                  <span
                    style={{
                      color: theme.palette.primary.main,
                      fontWeight: 600,
                    }}
                  >
                    {startDate.toDateString()}
                  </span>
                </Typography>
                <Typography variant={"body2"} className={classes.body}>
                  Days: {days.replace("days", "")}
                </Typography>
                <Typography variant={"body2"} className={classes.body}>
                  Grade: {props.grade}
                </Typography>
                <Typography variant={"body2"} className={classes.body}>
                  Distance: {props.distance}km
                </Typography>
              </Grid>
              <Grid
                item
                container
                xs={12}
                justify="space-between"
                alignItems="flex-end"
              >
                <Grid item xs={5}>
                  <Typography variant={"body2"} className={classes.body}>
                    <b>Price</b>:{" "}
                    <span style={{ color: "#FB0051", fontWeight: 600 }}>
                      ${props.price}.00
                    </span>{" "}
                  </Typography>
                </Grid>
                <Grid item xs={7} align="right">
                  <Link
                    to={`/event/${props.slug}`}
                    state={{ slug: props.slug }}
                  >
                    <Button
                      variant="outlined"
                      style={{
                        borderColor: theme.palette.primary.main,
                        color: theme.palette.primary.main,
                        borderRadius: 2,
                        fontSize: 14,
                      }}
                    >
                      View Trip
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ) : (
        <Card className={classes.card}>
          <Grid container>
            <Grid item xs={4}>
              <CardMedia
                component={featuredImage}
                alt="Contemplative Reptile"
                title={props.title}
                image="Event Image"
              />
            </Grid>
            <Grid item container xs={8} justify="space-between">
              <Grid container style={{ padding: 10 }}>
                <Grid item container xs={12} md={8} alignContent="flex-start">
                  <Grid item xs={12}>
                    <Typography
                      gutterBottom
                      variant="body2"
                      className={classes.continentCat}
                    >
                      <span style={{ color: theme.palette.primary.main }}>
                        {props.continent}
                      </span>
                      {" - " + props.category}
                    </Typography>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="h2"
                      className={classes.title}
                    >
                      {props.title}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      gutterBottom
                      variant="body2"
                      component="h2"
                      className={classes.body}
                    >
                      Date:{" "}
                      <span
                        style={{
                          color: theme.palette.primary.main,
                          fontWeight: 600,
                        }}
                      >
                        {startDate.toDateString()}
                      </span>
                    </Typography>
                    <Typography variant={"body2"} className={classes.body}>
                      Days: {days}, Grade: {props.grade}, Distance:{" "}
                      {props.distance}km
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={12}
                    justify="space-between"
                    alignItems="center"
                    style={{ marginTop: 5 }}
                  >
                    <Grid item xs={5}>
                      <Typography variant={"body2"} className={classes.body}>
                        <b>Price</b>:{" "}
                        <span style={{ color: "#FB0051", fontWeight: 600 }}>
                          ${props.price}.00
                        </span>{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  justify="flex-end"
                  xs={12}
                  md={4}
                  alignContent="flex-end"
                >
                  <Grid item xs={12} align="right">
                    <Link
                      to={`/event/${props.slug}`}
                      state={{ slug: props.slug }}
                    >
                      <Button
                        variant="outlined"
                        style={{
                          borderColor: theme.palette.primary.main,
                          color: theme.palette.primary.main,
                          borderRadius: 2,
                          fontSize: 12,
                        }}
                      >
                        View Trip
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      )}
    </>
  );
};
export default EventCard;
